{
    window.clone = function (obj) {
        let newObj = (obj instanceof Array) ? [] : {};
        for (let i in obj) {
            if (Object.prototype.hasOwnProperty.call(obj, i)) {
                if (i === 'clone') continue;
                if (obj[i] && typeof obj[i] == "object") {
                    newObj[i] = window.clone(obj[i]);
                } else {
                    newObj[i] = obj[i];
                }
            }
        }
        return newObj;
    };

    window.optimize = function (arr) {
        for (let key in arr) {
            if (Object.prototype.hasOwnProperty.call(arr, key)) {
                let val = arr[key];
                if (val instanceof String)
                    if (!val || isNaN(val)) arr[key] = 0;
            }
        }
        return arr;
    };

    window.array_unique = function (ar) {
        let unique = [];
        for (let i = 0; i < ar.length; i++)
            if (Object.prototype.hasOwnProperty.call(ar, i)) {
                if (unique.indexOf(ar[i]) === -1)
                    unique.push(ar[i]);
            }
        return unique;
    };


    window.in_array = function (v, arr) {
        let idx = arr.indexOf(v);
        return idx !== -1;

    };


    window.rand_fn = function (min, max) {
        return Math.floor(Math.random() * (max - min) + min);
    };


    window.isEmptyObject = function (obj) {
        if (obj)
            return Object.entries(obj).length === 0 && obj.constructor === Object;
        return true;
    };

    window.hasClass = function (el, cl) {
        let regex = new RegExp('(?:\\s|^)' + cl + '(?:\\s|$)');
        return !!el.className.match(regex);
    };

    window.addClass = function (el, cl) {
        el.className += ' ' + cl;
    };

    window.removeClass = function (el, cl) {
        let regex = new RegExp('(?:\\s|^)' + cl + '(?:\\s|$)');
        el.className = el.className.replace(regex, ' ');
    };

    window.toggleClass = function (el, cl) {
        window.hasClass(el, cl) ? window.removeClass(el, cl) : window.addClass(el, cl);

    };


    window.number_format = function (number, decimals, dec_point, thousands_sep) {
        number = (number + '').replace(/[^0-9+\-Ee.]/g, '');
        let n = !isFinite(+number) ? 0 : +number,
            prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
            sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
            dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
            s;
        let toFixedFix = function (n, prec) {
            let k = Math.pow(10, prec);
            return '' + (Math.round(n * k) / k)
                .toFixed(prec);
        };
        // Fix for IE parseFloat(0.55).toFixed(0) = 0;
        s = (prec ? toFixedFix(n, prec) : '' + Math.round(n))
            .split('.');
        if (s[0].length > 3) {
            s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
        }
        if ((s[1] || '')
            .length < prec) {
            s[1] = s[1] || '';
            s[1] += new Array(prec - s[1].length + 1)
                .join('0');
        }
        return s.join(dec);
    };


    window.phoneFormat = function (phone) {
        let str = phone.replace(/\D/g, '').split(/(?=.)/);
        let num = str.slice(0, 11);
        if (num[0] === '8') num[0] = '7';
        if (num[0] !== '+') {
            str = '+' + num.join('');
            num = str.slice(0, 11);
        }
        str = num.join('');
        return str;
    };


    window.gen_randNum = function (n) {
        let rand_fn = function (min, max) {
            return Math.floor(Math.random() * (max - min) + min);
        };
        let arg = [];
        for (let i = 0; i < n; i++) arg.push(rand_fn(48, 58), rand_fn(65, 91), rand_fn(97, 123));
       // for (let j, x, y = arg.length; y; j = parseInt(Math.random() * y), x = arg[--y], arg[y] = arg[j], arg[j] = x) ;
        return String.fromCharCode.apply(this, arg);
    };


    window.formatDateFromStr = function (str) {
        let tm = str.split('.');
        let day = parseInt(tm[0]);
        let month = parseInt(tm[1]) - 1;
        let year = parseInt(tm[2]);
        let d = new Date(year, month, day);
        day = d.getDate();
        month = d.getMonth() + 1;
        year = d.getFullYear();
        if (day < 10) day = "0" + day.toString();
        if (month < 10) month = "0" + month.toString();
        year = year.toString();
        return day + "." + month + "." + year;
    };

    window.screenSize = function () {
        let w = window,
            d = document,
            e = d.documentElement,
            g = d.getElementsByTagName('body')[0],
            x = w.innerWidth || e.clientWidth || g.clientWidth,
            y = w.innerHeight || e.clientHeight || g.clientHeight;
        return {x: parseInt(x), y: parseInt(y)};
    };


    window.dynamicSort = function(property) {
        let sortOrder = 1;
        if(property[0] === "-") {
            sortOrder = -1;
            property = property.substr(1);
        }
        return function (a,b) {
            if(sortOrder === -1){
                return b[property].localeCompare(a[property]);
            }else{
                return a[property].localeCompare(b[property]);
            }
        }
    };
}

 export default {};
